import { useState } from 'react';
import { ButtonGroup, IconButton, Menu, MenuItem, styled } from '@mui/material';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import theme from '../../Theme';
import { ClientBillingReportType } from '../../gql-types.generated';

const ReportButton = styled(IconButton)((props) => ({
  padding: '0',
  '&:hover': {
    color: theme.palette.primary.dark,
    fontWeight: 'bold'
  }
}));

const ArrowButton = styled(IconButton)((props) => ({
  padding: '0',
  '&:hover': {
    color: theme.palette.primary.dark,
    fontWeight: 'bold'
  }
}));

interface BillingReportSplitButtonProps {
  onDailyReportClick: () => void;
  onPartnerMonthlyReportClick: () => void;
  disabled?: boolean;
}

export const BillingReportSplitButton: React.FC<BillingReportSplitButtonProps> = (props) => {
  const { onDailyReportClick, onPartnerMonthlyReportClick, disabled = false } = props;
  
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isReportMenuOpen = Boolean(anchorEl);

  const onReportMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    // this button could be inside of a grid that could have a click event,
    // stopPropagation to prevent that click event from firing
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleReportMenuClose = (event: React.MouseEvent<any>) => {
    // this button could be inside of a grid that could have a click event,
    // stopPropagation to prevent that click event from firing
    event.stopPropagation();
    
    let buttonDataSet = (event.target as HTMLElement).dataset;
    
    if (buttonDataSet.operation === ClientBillingReportType.Daily) {
      onDailyReportClick();
    }
    else if (buttonDataSet.operation === ClientBillingReportType.PartnerMonthly) {
      onPartnerMonthlyReportClick();
    }
    
    setAnchorEl(null);
  };

  const handleMainButtonClick = (event: React.MouseEvent<any>) => {
    // this button could be inside of a grid that could have a click event,
    // stopPropagation to prevent that click event from firing
    event.stopPropagation();
    
    onDailyReportClick();
    setAnchorEl(null);
  };

  return (
    <>
      <ButtonGroup variant="outlined" size="small" aria-label="billing report button group">
        <ReportButton
          color="primary"
          size="medium"
          disabled
        >
          {<AssessmentIcon />}
        </ReportButton>
        <ArrowButton
          id="report-options-button"
          aria-label="Report Options Menu"
          aria-haspopup="menu"
          title="Download Report"
          color="primary"
          onClick={onReportMenuClick}
          disabled={disabled}
        >
          <ArrowDropDownIcon />
        </ArrowButton>
      </ButtonGroup>
      <Menu
        id="report-options-menu"
        anchorEl={anchorEl}
        open={isReportMenuOpen}
        onClose={handleReportMenuClose}
      >
        <MenuItem
          data-operation={ClientBillingReportType.Daily}
          onClick={handleReportMenuClose}
        >
          Daily
        </MenuItem>
        <MenuItem
          data-operation={ClientBillingReportType.PartnerMonthly}
          onClick={handleReportMenuClose}
        >
          Partner Monthly
        </MenuItem>
      </Menu> 
    </>
  );
};
